import {combineReducers} from "redux";

import {IAppError, reduceLatestQuery, reduceRequestErrors, reduceRequestState, reduceResponse, reduceResponseField, RequestState} from "@pg-mono/request-state";

import {IOfferListOffer} from "../../types/IOfferListOffer";
import {fetchAllOffersForCountTypes} from "../actions/fetch_all_offers_for_count";
import {fetchOfferListTypes} from "../actions/fetch_offer_list";
import {fetchOfferListPromotionalOffersCountTypes} from "../actions/fetch_offer_list_promotional_offers_count";
import {fetchPrivilegedOfferListTypes} from "../actions/fetch_privileged_offer_list";
import {fetchPropertiesCountTypes} from "../actions/fetch_properties_count";
import {fetchSoonFinishedOfferListTypes} from "../actions/fetch_soon_finished_offer_list";
import {fetchUnavailableOfferListTypes} from "../actions/fetch_unavailable_offer_list";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

export interface IOfferListListStore {
    allOffers: IOfferListOffer[];
    offers: IOfferListOffer[];
    privileged_offers: IOfferListOffer[];
    unavailable_offers: IOfferListOffer[];
    soon_finished_offers: IOfferListOffer[];
    unavailable_offers_page: number;
    unavailable_offers_count: number;
    soon_finished_offers_count: number;
    count: number;
    page: number;
    page_size: number;
    requestState: RequestState;
    latestQuery: IOfferListLatestQuery;
    error: IAppError | null;
    propertiesCount: number | null;
    propertiesCountRequestState: RequestState;
    listingContextPromotionalOffersCount: number | null;
    listingContextPromotionalOffersCountRequestState: RequestState;
}

export const offerListListReducer = combineReducers({
    allOffers: reduceResponseField<IOfferListOffer[]>(fetchAllOffersForCountTypes, "allOffers", []),
    offers: reduceResponseField<IOfferListOffer[]>(fetchOfferListTypes, "offers", []),
    privileged_offers: reduceResponseField<IOfferListOffer[]>(fetchPrivilegedOfferListTypes, "offers", []),
    unavailable_offers: reduceResponseField<IOfferListOffer[]>(fetchUnavailableOfferListTypes, "offers", []),
    soon_finished_offers: reduceResponseField(fetchSoonFinishedOfferListTypes, "offers", []),
    unavailable_offers_page: reduceResponseField<number>(fetchUnavailableOfferListTypes, "page", 0),
    unavailable_offers_count: reduceResponseField<number>(fetchUnavailableOfferListTypes, "count", 0),
    soon_finished_offers_count: reduceResponseField<number>(fetchSoonFinishedOfferListTypes, "count", 0),
    count: reduceResponseField<number>(fetchOfferListTypes, "count", 0),
    page: reduceResponseField<number>(fetchOfferListTypes, "page", 0),
    page_size: reduceResponseField<number>(fetchOfferListTypes, "page_size", 0),
    requestState: reduceRequestState(fetchOfferListTypes),
    latestQuery: reduceLatestQuery(fetchOfferListTypes),
    error: reduceRequestErrors(fetchOfferListTypes),
    propertiesCount: reduceResponse<number>(fetchPropertiesCountTypes),
    propertiesCountRequestState: reduceRequestState(fetchPropertiesCountTypes),
    listingContextPromotionalOffersCount: reduceResponse<number>(fetchOfferListPromotionalOffersCountTypes),
    listingContextPromotionalOffersCountRequestState: reduceRequestState(fetchOfferListPromotionalOffersCountTypes)
});
import {combineReducers} from "redux";

import {IAppError, reduceLatestQuery, reduceRequestErrors, reduceRequestState, reduceResponse, reduceResponseField, RequestState} from "@pg-mono/request-state";

import {IOfferListOffer} from "../../types/IOfferListOffer";
import {fetchAllOffersForCountTypes} from "../actions/fetch_all_offers_for_count";
import {fetchOfferListTypes} from "../actions/fetch_offer_list";
import {fetchOfferListPromotionalOffersCountTypes} from "../actions/fetch_offer_list_promotional_offers_count";
import {fetchPrivilegedOfferListTypes} from "../actions/fetch_privileged_offer_list";
import {fetchPropertiesCountTypes} from "../actions/fetch_properties_count";
import {fetchSoonFinishedOfferListTypes} from "../actions/fetch_soon_finished_offer_list";
import {fetchUnavailableOfferListTypes} from "../actions/fetch_unavailable_offer_list";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

export interface IOfferListListStore {
    allOffers: IOfferListOffer[];
    offers: IOfferListOffer[];
    privileged_offers: IOfferListOffer[];
    unavailable_offers: IOfferListOffer[];
    soon_finished_offers: IOfferListOffer[];
    unavailable_offers_page: number;
    unavailable_offers_count: number;
    soon_finished_offers_count: number;
    count: number;
    page: number;
    page_size: number;
    requestState: RequestState;
    latestQuery: IOfferListLatestQuery;
    error: IAppError | null;
    propertiesCount: number | null;
    propertiesCountRequestState: RequestState;
    listingContextPromotionalOffersCount: number | null;
    listingContextPromotionalOffersCountRequestState: RequestState;
}

export const offerListListReducer = combineReducers({
    allOffers: reduceResponseField<IOfferListOffer[]>(fetchAllOffersForCountTypes, "allOffers", []),
    offers: reduceResponseField<IOfferListOffer[]>(fetchOfferListTypes, "offers", []),
    privileged_offers: reduceResponseField<IOfferListOffer[]>(fetchPrivilegedOfferListTypes, "offers", []),
    unavailable_offers: reduceResponseField<IOfferListOffer[]>(fetchUnavailableOfferListTypes, "offers", []),
    soon_finished_offers: reduceResponseField(fetchSoonFinishedOfferListTypes, "offers", []),
    unavailable_offers_page: reduceResponseField<number>(fetchUnavailableOfferListTypes, "page", 0),
    unavailable_offers_count: reduceResponseField<number>(fetchUnavailableOfferListTypes, "count", 0),
    soon_finished_offers_count: reduceResponseField<number>(fetchSoonFinishedOfferListTypes, "count", 0),
    count: reduceResponseField<number>(fetchOfferListTypes, "count", 0),
    page: reduceResponseField<number>(fetchOfferListTypes, "page", 0),
    page_size: reduceResponseField<number>(fetchOfferListTypes, "page_size", 0),
    requestState: reduceRequestState(fetchOfferListTypes),
    latestQuery: reduceLatestQuery(fetchOfferListTypes),
    error: reduceRequestErrors(fetchOfferListTypes),
    propertiesCount: reduceResponse<number>(fetchPropertiesCountTypes),
    propertiesCountRequestState: reduceRequestState(fetchPropertiesCountTypes),
    listingContextPromotionalOffersCount: reduceResponse<number>(fetchOfferListPromotionalOffersCountTypes),
    listingContextPromotionalOffersCountRequestState: reduceRequestState(fetchOfferListPromotionalOffersCountTypes)
});
